export const apiName: string = 'divisoes';
export const divisoesRoute: string = 'divisoes';
export const divisoesStorage: string = 'divisoes';
export const divisoesModuleName: any = {plural: 'Divisões', single: 'Divisão'};

export const divisoesQuery: any = {
  "where":{
    "ativo":true,
    "divisao":{"regexp":"/REPLACEHERE/i"}
  },
  "order":"divisao"
};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/divisoes/shared/data.service.ts
 **/